import { render, staticRenderFns } from "./ImageIcon.vue?vue&type=template&id=48fb5e20&scoped=true"
import script from "./ImageIcon.vue?vue&type=script&lang=js"
export * from "./ImageIcon.vue?vue&type=script&lang=js"
import style0 from "./ImageIcon.vue?vue&type=style&index=0&id=48fb5e20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fb5e20",
  null
  
)

export default component.exports